/* istanbul ignore file */
import axios from "axios"
import {createAxiosInstance} from "@next/axios"
import logger from "@next/core-logger"
import env from "../../config/env"

const {PORT, DEV_URL_OVERRIDE} = env

const axiosInstance = createAxiosInstance({
    PORT,
    REACT_APP_APP_URL: DEV_URL_OVERRIDE,
})

const externalCallAxiosInstance = axios.create({})
externalCallAxiosInstance.interceptors.response.use(
    response => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response
    },
    error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        logger.error(error, "axios-response-error")
        return Promise.reject(error)
    },
)

export {axiosInstance, externalCallAxiosInstance}
